import WorldBorder from "./world-border";

class SphericalWorld extends WorldBorder {
    constructor(center, radius) {
        super();
        this.center = center;
        this.radius = radius - this.borderOffset;
    }

    limitToBorder(position) {
        this.distance.subVectors(position, this.center);
        const maxDistance = this.distance.clone().normalize().multiplyScalar(this.radius);

        if (this.distance.length() > this.radius) {
            position.addVectors(this.center, maxDistance);
        }
    }
}

export default SphericalWorld;
